import { render, staticRenderFns } from "./EmployeeProfileAsideMenu.vue?vue&type=template&id=fd989042&scoped=true&"
import script from "./EmployeeProfileAsideMenu.vue?vue&type=script&lang=js&"
export * from "./EmployeeProfileAsideMenu.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeProfileAsideMenu.vue?vue&type=style&index=0&id=fd989042&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd989042",
  null
  
)

export default component.exports